import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
// every service exposes system/plugin/states; datacollector always runs and rarely changes
const service = 'jernygateway';

class PluginStateService extends ServiceBase {
    /**
     * Fetches the state of all registered service instances (plugin registry).
     * @returns {Promise} response with { count, items: [{instance, plugin, state, app, machine, user, env, gcMem, createdOn, modifiedOn}] }
     */
    getPluginStates = () => {
        const url = `${baseUrl}/${service}/system/plugin/states`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };
}

const pluginStateService = new PluginStateService();
export default pluginStateService;
